import React, { useMemo, useState } from "react";
import { Button } from "../../general/Button/Button";
import "./ReceiptsSettings.scss";
import { TablePageHeader } from "../../pageHeader/TablePageHeader";
import { PlainModal, StandardModalHeader } from "../../general/Modal/Modal";

import { useAddReceiptEmail, useReceiptEmails } from "../../../api/user.api";
import { ReceiptEmails } from "./ReceiptEmails";
import { AddReceiptsEmail } from "./AddReceiptsEmail";

export const ReceiptsSettings: React.FC = () => {
    const [search, setSearch] = useState("");
    const [addingReceiptsEmail, setAddingReceiptsEmail] = useState(false);

    const { data, isPending } = useReceiptEmails();
    const addMmeber = useAddReceiptEmail();

    const emailToDisplay = useMemo(() => {
        if (!search) {
            return data;
        }

        return (
            data?.filter((email) =>
                email.email.toLowerCase().includes(search.toLowerCase()),
            ) ?? []
        );
    }, [data, search]);

    return (
        <div className="settings__receipts">
            <header className="settings__header">
                <h3>Receipts</h3>
            </header>

            <section>
                <header className="settings__receipts__address">
                    <small>Receipt forwarding address</small>
                    <span className="settings__receipts__receipts-email">
                        receipts@kick.co
                    </span>
                </header>

                <TablePageHeader search={search} onSearchChange={setSearch}>
                    <Button
                        onClick={() => setAddingReceiptsEmail(true)}
                        variant="secondary"
                    >
                        Add email address
                    </Button>
                </TablePageHeader>

                <ReceiptEmails
                    emails={emailToDisplay ?? []}
                    isLoading={isPending}
                />
            </section>

            <PlainModal
                show={addingReceiptsEmail}
                onHide={() => setAddingReceiptsEmail(false)}
            >
                <StandardModalHeader>Add Receipts Email</StandardModalHeader>

                <AddReceiptsEmail
                    onAddEmail={async (email) => {
                        await addMmeber.mutateAsync({ email });
                        setAddingReceiptsEmail(false);
                    }}
                    onCancel={() => setAddingReceiptsEmail(false)}
                />
            </PlainModal>
        </div>
    );
};
